import ReactLoading from 'react-loading';
import './Loading.css'

const Loading = () => {
    return (
        <div>
            <div className="loadingio-spinner-spinner-3fgwzj5ao1y"><div className="ldio-o24l4wkbfkc">
<div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
</div></div>
        </div>
    )
    // return <ReactLoading type='spin' color='#ffffff' className='loading'></ReactLoading>
}

export default Loading